import * as KidneyConstants from "./KidneyConstants.js";

const display_kidneyDeviceTable = (props) => {
  let formData = props.profileData.Patient_Data.kidney_device.form_res;
  formData.sort((a, b) => new Date(a.x) - new Date(b.x));
  let columns_hours = [""];
  let multiple_dates = false;

  if (formData.length > 1) {
    let first_date = new Date(formData[0].x);
    let last_date = new Date(formData[formData.length - 1].x);
    if (first_date.getDate() !== last_date.getDate() || first_date.getMonth() !== last_date.getMonth() || first_date.getFullYear() !== last_date.getFullYear()) {
      multiple_dates = true;
    }
  }

  formData.forEach((kidneyData) => {
    let date = new Date(kidneyData.x);
    if (multiple_dates) {
      let new_date = date.getDate() + "/";
      if (date.getMonth() + 1 > 9) {
        new_date += date.getMonth() + 1 + "/";
      } else {
        new_date += "0" + (date.getMonth() + 1) + "/";
      }
      new_date += date.getFullYear() + " ";
      new_date += date.toTimeString().split(":")[0] + ":";
      new_date += date.toTimeString().split(":")[1];
      columns_hours.push(new_date);
    } else {
      let new_date = "";
      new_date += date.toTimeString().split(":")[0] + ":";
      new_date += date.toTimeString().split(":")[1];
      columns_hours.push(new_date);
    }
  });

  let rearrangedData = formData.map((elt) => {
    return {
      x: elt.x,
      y: JSON.parse(elt.y),
    };
  });

  const rowHeads = [
    { label: "session_state", name: props.intl.formatMessage({ id: "kidney.form.machine.session.session_state" }) },
    { label: "dry_weight_at_session_start", name: props.intl.formatMessage({ id: "kidney.form.machine.dry_weight_at_session_start" }) },
    { label: "real_weight_at_session_start", name: props.intl.formatMessage({ id: "kidney.form.machine.real_weight_at_session_start" }) },
    { label: "real_weight", name: props.intl.formatMessage({ id: "kidney.form.machine.real_weight" }) },
    // 2 calculated fields
    { label: "weight_diff_with_start", name: props.intl.formatMessage({ id: "kidney.form.machine.weight_difference" }) },
    { label: "weight_diff_with_dry", name: props.intl.formatMessage({ id: "kidney.form.machine.weight_variation_with_dry" }) },

    { label: "vein_pressure", name: props.intl.formatMessage({ id: "kidney.form.machine.one" }) },
    { label: "blood_pressure", name: props.intl.formatMessage({ id: "kidney.form.machine.two" }) },
    { label: "bags_volume", name: props.intl.formatMessage({ id: "kidney.form.machine.three" }) },
    { label: "ultrafiltration_rate", name: props.intl.formatMessage({ id: "kidney.form.machine.four" }) },
    { label: "peritoneal_liquid", name: props.intl.formatMessage({ id: "kidney.form.machine.liquid" }) },
    { label: "compression_duration", name: props.intl.formatMessage({ id: "kidney.form.machine.five" }) },
  ];

  const liquidAspects = KidneyConstants.getBloodViscosityOptionsMap(props.intl.formatMessage);
  const sessionStates = KidneyConstants.getSessionStateOptionsMap(props.intl.formatMessage);

  const findValueToDisplay = (rearrangedData, label, index) => {
    switch (label) {
      case "peritoneal_liquid":
        return liquidAspects[findParamValue(rearrangedData, label, index)];
      case "session_state":
        return sessionStates[findParamValue(rearrangedData, label, index)];
      case "weight_diff_with_start":
        return differenceBetweenNumbers(findParamValue(rearrangedData, "real_weight", index), findParamValue(rearrangedData, "real_weight_at_session_start", index));
      case "weight_diff_with_dry":
        return differenceBetweenNumbers(findParamValue(rearrangedData, "real_weight", index), findParamValue(rearrangedData, "dry_weight_at_session_start", index));

      default:
        return findParamValue(rearrangedData, label, index);
    }
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        overflow: "auto",
      }}
    >
      {props.intl.formatMessage({ id: "kidney.form.machine.title" })}
      <table
        className="table table-striped table-bordered"
        style={{
          fontSize: "90%",
          width: "100%",
        }}
      >
        <thead>
          <tr>
            {columns_hours.map((column, index) => (
              <th key={`h-${index}`}>{column}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rowHeads.map((r, index) => (
            <tr key={`data-${index}`}>
              <td>{r.name}</td>
              {rearrangedData.map((_, i) => (
                <td key={`data-${index}-${i}`}>{findValueToDisplay(rearrangedData, r.label, i)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const display_kidneyBloodTable = (props) => {
  let formData = props.profileData.Patient_Data.kidney_blood.form_res;
  formData.sort((a, b) => new Date(a.x) - new Date(b.x));
  let columns_hours = [""];
  let multiple_dates = false;

  if (formData.length > 1) {
    let first_date = new Date(formData[0].x);
    let last_date = new Date(formData[formData.length - 1].x);
    if (first_date.getDate() !== last_date.getDate() || first_date.getMonth() !== last_date.getMonth() || first_date.getFullYear() !== last_date.getFullYear()) {
      multiple_dates = true;
    }
  }

  formData.forEach((kidneyData) => {
    let date = new Date(kidneyData.x);
    if (multiple_dates) {
      let new_date = date.getDate() + "/";
      if (date.getMonth() + 1 > 9) {
        new_date += date.getMonth() + 1 + "/";
      } else {
        new_date += "0" + (date.getMonth() + 1) + "/";
      }
      new_date += date.getFullYear() + " ";
      new_date += date.toTimeString().split(":")[0] + ":";
      new_date += date.toTimeString().split(":")[1];
      columns_hours.push(new_date);
    } else {
      let new_date = "";
      new_date += date.toTimeString().split(":")[0] + ":";
      new_date += date.toTimeString().split(":")[1];
      columns_hours.push(new_date);
    }
  });

  let rearrangedData = formData.map((elt) => {
    return {
      x: elt.x,
      y: JSON.parse(elt.y),
    };
  });

  const rowHeads = [
    { label: "gfr", name: props.intl.formatMessage({ id: "kidney.form.blood.one" }) },
    { label: "creatine", name: props.intl.formatMessage({ id: "kidney.form.blood.two" }) },
    { label: "uric_acid", name: props.intl.formatMessage({ id: "kidney.form.blood.three" }) },
    { label: "albuminuria_ratio", name: props.intl.formatMessage({ id: "kidney.form.blood.four" }) },
    { label: "glucose", name: props.intl.formatMessage({ id: "kidney.form.blood.five" }) },
  ];

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        overflow: "auto",
      }}
    >
      {props.intl.formatMessage({ id: "kidney.form.blood.title" })}
      <table
        className="table table-striped table-bordered"
        style={{
          fontSize: "90%",
          width: "100%",
        }}
      >
        <thead>
          <tr>
            {columns_hours.map((column, index) => (
              <th key={`h-${index}`}>{column}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rowHeads.map((r, index) => (
            <tr key={`data-${index}`}>
              <td>{r.name}</td>
              {rearrangedData.map((_, i) => (
                <td key={`data-${index}-${i}`}>{findParamValue(rearrangedData, r.label, i)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// data is form data and needs to be json parsed :
// let data = formData.map(elt => {
//   return {
//     x: elt.x,
//     y: JSON.parse(elt.y)
//   }
// });
// and data is sorted : index instead of x
const findParamValue = (data, param, index) => {
  if (data && data.length > 0) {
    if (data[index].y && data[index].y.length > 0) {
      let res = data[index].y.find((item) => item.label === param);
      return res == null ? null : res.value;
    }
  }
  return null;
};

/**
 * 
 * @param {*} num1 string
 * @param {*} num2 string
 * @returns num1 - num2
 */
function differenceBetweenNumbers(num1, num2) {
  try {
    const num1Float = parseFloat(num1);
    const num2Float = parseFloat(num2);
    
    if (isNaN(num1Float) || isNaN(num2Float)) {
      return "?";
    }

    return num1Float - num2Float;
  } catch (error) {
    console.log("Unable to d the difference between " + num1 + " and " + num2);
  }
  return "?";
}

export default { display_kidneyDeviceTable, display_kidneyBloodTable };
